const vP18156 = require("../356.js");
const vP181562 = require("../357.js");
const vP181563 = require("../375.js");
const vP181564 = require("../376.js");
function f2159(p18157, p18158, p18159, p18160, p18161) {
  const v13958 = [].slice.call(arguments, 1);
  const v13959 = v13958.length;
  const v13960 = typeof v13958[v13959 - 1] == "function";
  if (!v13960 && !vP18156()) {
    throw new Error("Callback required as last argument");
  }
  if (v13960) {
    if (v13959 < 2) {
      throw new Error("Too few arguments provided");
    }
    if (v13959 === 2) {
      p18161 = p18159;
      p18159 = p18158;
      p18158 = p18160 = undefined;
    } else if (v13959 === 3) {
      if (p18158.getContext && typeof p18161 == "undefined") {
        p18161 = p18160;
        p18160 = undefined;
      } else {
        p18161 = p18160;
        p18160 = p18159;
        p18159 = p18158;
        p18158 = undefined;
      }
    }
  } else {
    if (v13959 < 1) {
      throw new Error("Too few arguments provided");
    }
    if (v13959 === 1) {
      p18159 = p18158;
      p18158 = p18160 = undefined;
    } else if (v13959 === 2 && !p18158.getContext) {
      p18160 = p18159;
      p18159 = p18158;
      p18158 = undefined;
    }
    return new Promise(function (p18162, p18163) {
      try {
        const v13961 = vP181562.create(p18159, p18160);
        p18162(p18157(v13961, p18158, p18160));
      } catch (e177) {
        p18163(e177);
      }
    });
  }
  try {
    const v13962 = vP181562.create(p18159, p18160);
    p18161(null, p18157(v13962, p18158, p18160));
  } catch (e178) {
    p18161(e178);
  }
}
exports.create = vP181562.create;
exports.toCanvas = f2159.bind(null, vP181563.render);
exports.toDataURL = f2159.bind(null, vP181563.renderToDataURL);
exports.toString = f2159.bind(null, function (p18164, p18165, p18166) {
  return vP181564.render(p18164, p18166);
});